export default "__VITE_ASSET__bfb1f8ad__"